import { ACTION_TYPES } from '../constants';

export default () => ({
  type: ACTION_TYPES.FETCH_ERROR
});
